import React from 'react'

import PostEditForm from './PostEditForm'

const PostEdit = () => {

  return (
    <>
      <h1>Post Edit</h1>
      <PostEditForm />
    </>
  )
}

export default PostEdit
